import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { AuthState, LoginDonePayload } from "./authActions";

const initialState: AuthState = {
  authUser: null,
  error: null,
  isLoggingOut: false,
  loading: false,
};

export const authSlide = createSlice({
  initialState,
  name: "auth",
  reducers: {
    exitImpersonationSlice: (state) => {
      state.isLoggingOut = true;
      state.authUser = null;
    },
    loginDone: (state, action: PayloadAction<LoginDonePayload>) => {
      const { payload } = action;
      if (payload.error) {
        state.authUser = null;
        state.error = payload.error;
      } else if (payload.authUser) {
        state.authUser = payload.authUser;
        if (payload.isLoginOverride) {
          state.authUser.isLoginOverride = payload.isLoginOverride;
        }
      }
      state.loading = false;
    },
    logoutDone: (state) => {
      state.isLoggingOut = true;
      state.authUser = null;
    },
    setLoggingOutFlag: (state, action) => {
      state.isLoggingOut = action.payload;
    },
    startLogin: (state) => {
      state.loading = true;
      state.error = null;
      state.authUser = null;
    },
  },
});

export const { exitImpersonationSlice, startLogin, loginDone, logoutDone, setLoggingOutFlag } =
  authSlide.actions;
export default authSlide.reducer;
